var _rect, _path, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHamburgerToggler(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    x: 0.5,
    y: 0.5,
    fill: "#fff",
    rx: 11.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000093",
    d: "M10.667 15.334a.668.668 0 0 1-.474-1.14l2.2-2.194-2.2-2.193a.67.67 0 0 1 .947-.947l2.667 2.667a.668.668 0 0 1 0 .947L11.14 15.14a.667.667 0 0 1-.473.194Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    x: 0.5,
    y: 0.5,
    stroke: "#B5B5B5",
    rx: 11.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburgerToggler);
export default __webpack_public_path__ + "static/media/hamburgerToggler.f28ed0769b194ec7bdeaff5c3e238fd1.svg";
export { ForwardRef as ReactComponent };